// api.ts
import config from "@lib/config";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { Auth } from "aws-amplify";

export const riotApi = createApi({
  reducerPath: 'riotApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.API_ENDPOINT,
    prepareHeaders: async (headers) => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.getSignInUserSession()?.getIdToken().getJwtToken();
        if (!token) {
          throw new Error('No valid token found');
        }
        headers.set('authorization', `Bearer ${token}`);
      } catch (error) {
        // Log error but don't throw - let the API call fail naturally
        console.error('Error preparing headers:', error);
      }
      return headers;
    }
  }),
  tagTypes: ['User'], // Add any other tag types you need
  refetchOnMountOrArgChange: 15,
  refetchOnReconnect: true,
  refetchOnFocus: true,
  endpoints: () => {
    return {
      /**
       * base query does not implement endpoints.
       * endpoints are added by injection in the respective api slices.
       */
    };
  },
});

// Export hooks and utilities
export const {
  util: { resetApiState },
} = riotApi;
